import { api } from '@src/service/api'
import { Industry } from '@src/types/strapi/collections/industry'
import useSWR from 'swr'

export const useFactories = () => {
  return useSWR<Industry[]>('/factories', () => api.get<Industry[]>('/factories').then(res => res.data))
}
